import { Box, Button, Typography } from "@mui/material";
import face_book from "../../../../../assets/images/facebook.png";
import googeReview from "../../../../../assets/images/googeReview.png";
import dealerRater from "../../../../../assets/images/dealerRater.jpg";
import { useMediaQuery } from "@mui/material";
import { useVerification } from "../../../../../context/Verification.context";
import { useMutation } from "@apollo/client";
import { DEALER_APP_LINK } from "../../../../../graphql/mutation/mutation";
import { SendToMobileOutlined } from "@mui/icons-material";
import AppButton from "../../../../base/AppButton.component";
import { ensureAbsoluteUrl } from "../../../../../utils/Utils";
import { BiBorderRadius } from "react-icons/bi";
import TextUnAvailable from "./TextUnAvailable";
import { useState, useEffect } from "react";

const RatingResponse = ({
  artifact,
  setReviewScreen,
  isAIReview,
  onInteraction,
}) => {
  const verification = useVerification();
  const [dealerAppLink] = useMutation(DEALER_APP_LINK);
  const isMobile = useMediaQuery("(max-width:750px)");

  // State to track which button was clicked
  const [activeSuccessMessage, setActiveSuccessMessage] = useState(null);

  useEffect(() => {
    if (activeSuccessMessage) {
      const timer = setTimeout(() => {
        setActiveSuccessMessage(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [activeSuccessMessage]);

  const sendLink = (option, image) => {
    onInteraction?.();

    if (artifact?.id) {
      const newReviewResponse = {
        user_id: parseInt(verification?.customer?.userId),
        review_question_id: artifact.id,
        created_by: parseInt(verification?.employeeId),
        updated_by: parseInt(verification?.employeeId),
        isReview: true,
      };

      verification.setArtifactsResponse((prevState) => ({
        ...prevState,
        reviewResponse: prevState?.reviewResponse
          ? {
              ...prevState?.reviewResponse,
              isReview: true,
              review_question_id: artifact.id,
            }
          : newReviewResponse,
      }));

      setReviewScreen(true);

      if (image) {
  sessionStorage.setItem("returnToReview", "true");
  sessionStorage.setItem("reviewArtifactId", artifact?.id);
  window.open(ensureAbsoluteUrl(image?.url), "_blank");
}

    }

    if (option) {
      dealerAppLink({
        variables: {
          linkInput: {
            user_id: parseInt(verification?.customer?.userId),
            option,
          },
        },
      });

      // Set which button was clicked to show success message below it
      setActiveSuccessMessage(option);
    }
  };

  const renderReviewImages = (artifact) => {
    const reviewImages = [];

    if (artifact.facebook)
      reviewImages.push({
        src: face_book,
        url: artifact.facebook,
        option: "facebook",
        borderRadius: "80px",
      });

    if (artifact.google)
      reviewImages.push({
        src: googeReview,
        url: artifact.google,
        option: "google",
        borderRadius: "80px",
      });
    if (artifact.dealer_rater)
      reviewImages.push({
        src: dealerRater,
        url: artifact.dealer_rater,
        option: "dealer_rater",
      });

    return (
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        gap="10px"
        flexWrap="wrap"
        width={{
          xs: "80%", // <= 600px (phones)
          sm: "50%", // 600–900px (small tablets)
          md: "60%", // >= 900px
          lg: reviewImages.length <= 2 ? "60%" : "100%", // Adjust based on number of items
        }}
      >
        {reviewImages.map((image, index) => (
          <Box
            key={index}
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              borderRadius: "5px",
              bgcolor: isAIReview ? "white" : null,
              width: {
                xs: "60%", // <= 600px (phones)
                sm: "60%", // 600–900px (small tablets)
                md: "60%",
                lg: reviewImages.length <= 2 ? "55%" : "35%",
              },
              height: {
                xs: "auto",
                sm: "110px",
                md: "110px",
                lg: "110px",
              },
              maxWidth: reviewImages.length <= 2 ? "300px" : "250px", // Limit maximum width
              justifyContent: "center",
              p: "5px",
              border: "2px solid grey",
              position: "relative",
              overflow: "visible",
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              width="100%"
              position="relative"
            >
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={image.src}
                  width={isMobile ? 70 : 100}
                  height={isMobile ? 70 : 100}
                  alt="logo"
                  onClick={() => sendLink("", image)}
                  style={{
                    cursor: "pointer",
                    objectFit: "contain",
                    borderRadius: image.borderRadius,
                  }}
                />
              </Box>
              <Box
                sx={{
                  position: "relative",
                  // display: "flex",
                  // justifyContent: "flex-end",
                  // alignItems:"end",
                }}
              >
                <Button
                  variant="text"
                  onClick={() => sendLink(image.option)}
                  sx={{
                    width: "40%",
                    height: "10%",
                    fontSize: {
                      xs: "12px",
                      sm: "16px",
                      md: "16px",
                      lg: "16px",
                    },
                    textTransform: "none",
                    color: "#00AB55",
                    // borderRadius: "0px",
                    "&:hover": {
                      border: "2px solid #007a3a",
                    },
                    borderLeft: "1px solid grey",
                    display: "flex",
                    // justifyContent: "end",
                    // alignItems: "end",
                    // display: "flex",

                    ml: {
                      xs: 1,
                      sm: 1,
                      md: 0,
                      lg: 0.5,
                    },
                    pl: {
                      xs: 1.5,
                      sm: 1.5,
                      md: 0,
                      lg: 1,
                    },
                  }}
                >
               <Typography sx={{ textAlign: "center",display:"flex", alignItems:"end", justifyContent:"end" }}>
  {verification?.aiData?.spanish
    ? "Enviar al teléfono"
    : "Send to Phone"}
</Typography>

                </Button>
              </Box>
            </Box>
            {/* Success message positioned absolutely below the entire box */}
            {activeSuccessMessage === image.option && (
              <Box
                sx={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  mt: 0.5,
                  zIndex: 1,
                  animation: "fadeInOut 3s ease-in-out",
                  width: "max-content",
                  maxWidth: "200px",
                }}
              >
                <Typography
                  variant="caption"
                  color="#C18803"
                  bgcolor="#FBF2D6"
                  sx={{
                    p: 0.5,
                    // borderRadius: 1,
                    textAlign: "center",
                    display: "block",
                    whiteSpace: "nowrap",
                  }}
                >
                  {verification?.aiData?.spanish
                    ? "¡Enviado a tu teléfono!"
                    : "Texted to your phone!"}
                </Typography>
              </Box>
            )}
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Box
      gap={"5px"}
      width={"100%"}
      position="relative"
      sx={{
        marginBottom: !isAIReview ? "30px" : "0px", // Add gap at bottom when AI is off
      }}
    >
      {!isAIReview && (
        <TextUnAvailable
          text={artifact?.message}
          es_text={artifact?.es_message}
        />
      )}

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        {renderReviewImages(artifact)}
      </Box>

      {/* Add CSS animation for fade in/out */}
      <style jsx>{`
        @keyframes fadeInOut {
          0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.8);
          }
          15% {
            opacity: 1;
            transform: translateX(-50%) scale(1);
          }
          85% {
            opacity: 1;
            transform: translateX(-50%) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateX(-50%) scale(0.8);
          }
        }
      `}</style>
    </Box>
  );
};

export default RatingResponse;
